/**
 * MicronutrientSourceType - synchronized with the Prisma enum of the same name.
 *
 * Provenienza di una vitamina dichiarata sul profilo nutrizionale:
 * `NATURAL` e' presente naturalmente nell'alimento; `FORTIFICATION` e' stata
 * aggiunta (Reg. CE 1925/2006, art. 7(3)) e comporta l'obbligo di dichiarare la
 * quantita' totale presente in etichetta. La distinzione guida anche la banda
 * di tolleranza analitica applicabile (DG SANTE Guidance Dec. 2012, sez. 3 vs 5):
 * vedi `MICRONUTRIENT_REGISTRY` in `shared/src/nutrition/micronutrient-registry.ts`.
 */
export const MICRONUTRIENT_SOURCE_TYPES = ['NATURAL', 'FORTIFICATION'] as const;
export type MicronutrientSourceType = (typeof MICRONUTRIENT_SOURCE_TYPES)[number];
